import * as t from "io-ts";

export const OnlinePresence = t.intersection([
  t.type({
    q_online: t.union([
      t.literal("Yes, I can provide the details"),
      t.literal("No, I don't have this"),
    ]),
  }),
  t.partial({
    website: t.string,
    facebook: t.string,
    google: t.string,
  }),
]);

export interface OnlinePresence {
  q_online: "Yes, I can provide the details" | "No, I don't have this";
  website?: string;
  facebook?: string;
  google?: string;
}
